import QueryRenderer from './QueryRenderer';

export default QueryRenderer;
